/**
 * Email validation utilities
 * Provides consistent email validation across the application
 */

// Flexible email regex pattern that works with various TLD lengths
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates an email address format
 * @param email - The email address to validate
 * @returns boolean - True if email format is valid, false otherwise
 */
export const isValidEmailAddress = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};

/**
 * React Hook Form validation rules for required email fields
 */
export const emailValidationRules = {
  required: "Email address is required",
  pattern: {
    value: EMAIL_REGEX,
    message: "Invalid email address",
  },
};

/**
 * React Hook Form validation rules for optional email fields
 */
export const optionalEmailValidationRules = {
  pattern: {
    value: EMAIL_REGEX,
    message: "Invalid email address",
  },
};
